import Image from 'next/image'
import Link from 'next/link'
import { View } from 'react-native'
import { tv } from 'tailwind-variants'
import { z } from 'zod'

import {
  downloadButtonConfiguration,
  downloadPlayButtonConfiguration,
} from '@nxt-insurance/ui-kit/components/AppDownloadButtons/constants'

import { EVENTS } from '@/constants/analytics'
import { useAnalytics } from '@/context/AnalyticsContext'
import type { PortableTextTypeComponentProps } from '@portabletext/react'
import appStoreIconDark from '@ui-kit/assets/images/src/illustrations/appDownloadButtons/appStore_120x40.svg'
import appStoreIconLight from '@ui-kit/assets/images/src/illustrations/appDownloadButtons/appStore_light_130x39.svg'
import googlePlayIconDark from '@ui-kit/assets/images/src/illustrations/appDownloadButtons/playStore_135x40.svg'
import googlePlayIconLight from '@ui-kit/assets/images/src/illustrations/appDownloadButtons/playStore_light_130x39.svg'

const appDownloadButtons = z.object({
  _type: z.literal('appDownloadButtons'),
  theme: z.enum(['dark', 'light']).optional(),
})

const appDownloadStyles = tv({
  slots: {
    container: 'flex flex-row gap-4',
  },
})
export const AppDownloadButtons = (props: {
  sectionName: string
  node: PortableTextTypeComponentProps<unknown>
}) => {
  const value = appDownloadButtons.parse(props.node.value)
  const styles = appDownloadStyles()

  const appStoreIconColor = value.theme === 'light' ? appStoreIconLight : appStoreIconDark
  const googlePlayIconColor = value.theme === 'light' ? googlePlayIconLight : googlePlayIconDark

  const { track } = useAnalytics()

  const onClick = (store: string) =>
    track(EVENTS.AppDownload, { store, sectionName: props.sectionName })
  return (
    <View className={styles.container()}>
      <Link
        rel="noopener noreferrer"
        href={downloadButtonConfiguration.href}
        target="_blank"
        onClick={() => onClick('App Store')}
      >
        <Image src={appStoreIconColor} loader={({ src }) => src} unoptimized alt="App Store" />
      </Link>
      <Link
        rel="noopener noreferrer"
        href={downloadPlayButtonConfiguration.href}
        target="_blank"
        onClick={() => onClick('Google Play')}
      >
        <Image src={googlePlayIconColor} loader={({ src }) => src} unoptimized alt="Google Play" />
      </Link>
    </View>
  )
}
